import { useEffect } from 'react';
import { useAppSelector } from '../../store/hooks';

const STATIC_SELECTOR = 'meta[name="google-site-verification"][data-static-verification="1"]';

export default function MetaVerificationTags() {
  const googleRaw = useAppSelector((s) => s.storeSettings?.settings?.metaVerification?.google);
  const googleContent = googleRaw != null ? String(googleRaw).trim() : '';

  useEffect(() => {
    const staticTag = document.querySelector(STATIC_SELECTOR);

    if (googleContent) {
      if (staticTag) {
        staticTag.setAttribute('content', googleContent);
      } else {
        document.querySelectorAll('meta[name="google-site-verification"]:not([data-static-verification])').forEach((el) => el.remove());
        const meta = document.createElement('meta');
        meta.setAttribute('name', 'google-site-verification');
        meta.setAttribute('content', googleContent);
        meta.setAttribute('data-modamai-google-verification', 'api');
        document.head.appendChild(meta);
      }
      return undefined;
    }

    return undefined;
  }, [googleContent]);

  return null;
}
